import React, {
  Dispatch,
  FC,
  Fragment,
  ReactNode,
  SetStateAction,
} from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
type CustomAccordionProps = {
  children: ReactNode;
  title: string;
  className?: string;
  isExpanded?: boolean;
  setExpanded?: Dispatch<SetStateAction<boolean>>;
  noArrow?: boolean;
};
const CustomAccordion: FC<CustomAccordionProps> = ({
  children,
  title,
  className,
  isExpanded = true,
  setExpanded,
  noArrow,
}): JSX.Element => {
  return (
    <div className={`w-full h-auto ${className}`}>
      {isExpanded}
      <div
        className="w-full py-1 text-white lg:px-4 rounded-t-lg text-lg cursor-pointer bg-[#2563eb] flex items-center justify-between  font-semibold"
        onClick={() => setExpanded?.((prev) => !prev)}
      >
        {title}
        {!noArrow ? (
          <Fragment>
            {!isExpanded ? (
              <KeyboardArrowDownIcon sx={{ fontSize: "30px" }} />
            ) : (
              <KeyboardArrowUpIcon sx={{ fontSize: "30px" }} />
            )}
          </Fragment>
        ) : (
          <></>
        )}
      </div>
      <Box
        // sx={[
        //   { zIndex: 888, transition: "all 2s linear 2s" },
        //   isExpanded || isExpanded === undefined
        //     ? { height: "auto" }
        //     : isExpanded === false
        //     ? { height: "0px" }
        //     : { height: "auto" },
        // ]}
        sx={
          isExpanded
            ? { height: "auto", zIndex: 888, transition: "all 2s linear 2s" }
            : {
                height: "0px",
                overflow: "auto",
                zIndex: 888,
                transition: "all 2s linear 2s",
              }
        }
      >
        {children}
      </Box>
    </div>
  );
};

export default CustomAccordion;
